/**
 * Paths where Stripe.js fraud-preload should not run (no billing context).
 */
const STRIPE_PRELOAD_EXCLUDED_PREFIXES = [
    "/embed",
    "/player-error",
    "/monitoring",
    "/signup",
    "/login",
    "/email-verification",
    "/resetPassword",
    "/password-reset",
    "/onboard",
    "/setup-channel",
    "/setup-branding",
] as const;

/**
 * Returns whether Stripe.js should be fraud-preloaded for the current path.
 * Unknown/null pathnames are treated as "do not preload" so App Router hydration
 * cannot accidentally load Stripe on embed or other excluded surfaces.
 */
export function shouldPreloadStripeForPath(pathname: string | null | undefined): boolean {
    if (!pathname) {
        return false;
    }

    return !STRIPE_PRELOAD_EXCLUDED_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    );
}
